/******/ (() => { // webpackBootstrap
/*!**********************************************************!*\
  !*** ./_build/scripts/snippets/action-sticky-product.js ***!
  \**********************************************************/
class StickyProduct extends HTMLElement {
  constructor() {
    super();

    this.initAnchorBtn();
    this.initStickyActions();
  }

  setupListerners() {
    // rather than button click, do form submit instead
  }

  initAnchorBtn() {
    const anchorBtn = this.querySelector('[data-variant-anchor]');
    const productVariants = document.querySelector('[data-product-variants]');

    if (anchorBtn) {
      anchorBtn.addEventListener('click', function () {
        productVariants.scrollIntoView({
          block: 'end',
        });
      });
    }
  }

  initStickyActions() {
    const productForm = document.querySelector('[data-product-form]');
    const stickyAddToCartBtn = this.querySelector('[data-asp-add-to-cart]');
    const stickyElement = this;
    const productFormBtn = document.querySelector('[data-product-submit-button]');

    if (stickyAddToCartBtn) {
      const options = {
        root: null,
        rootMargin: '8px',
        threshold: 0,
      };

      stickyAddToCartBtn.addEventListener('click', function () {
        productFormBtn.click();
      });

      function onChange(changes, observer) {
        changes.forEach((change) => {
          if (change.intersectionRatio === 0) {
            stickyElement.classList.add('is-visible');
          } else {
            stickyElement.classList.remove('is-visible');
          }
        });
      }

      const observer = new IntersectionObserver(onChange, options);
      observer.observe(productForm);
    }
  }
}

customElements.define('sticky-product', StickyProduct);

/******/ })()
;